import angular from "angular";

angular
    .module('app')
    .component('courseLessons', {
        template: require('./course-lessons.html'),
        controller: ['$http', '$uibModal', 'Notifier', controller],
        bindings: {
            course: '<',
            chapters: '<',
        }
    });

function controller($http, $uibModal, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
    };

    $ctrl.upItem = function (chapter, ind, chapterInd) {
        if (ind > 0) {
            let t = chapter.lessons[ind - 1];
            chapter.lessons[ind - 1] = chapter.lessons[ind];
            chapter.lessons[ind] = t;
        } else if ($ctrl.chapters[chapterInd - 1]) {
            let b = chapter.lessons[ind];
            $ctrl.chapters[chapterInd - 1].lessons.push(b);
            chapter.lessons.shift();
        } else {

        }
    };

    $ctrl.downItem = function (chapter, ind, chapterInd) {

        if (ind < chapter.lessons.length - 1) {
            let t = chapter.lessons[ind + 1];
            chapter.lessons[ind + 1] = chapter.lessons[ind];
            chapter.lessons[ind] = t;
        } else if ($ctrl.chapters[chapterInd + 1]) {
            let t = chapter.lessons[ind];
            $ctrl.chapters[chapterInd + 1].lessons.unshift(t);
            chapter.lessons.pop();
        } else {

        }
    };

    $ctrl.changeLessonOrder = function () {
        let per = true;
        $ctrl.chapters.forEach(function (chapter) {
            if (chapter.lessons.length != 0) {
                $http.post(`/admin/courses/${$ctrl.course.id}/chapters/${chapter.id}/change-lesson-order`, {lessons: chapter.lessons}).then(
                    function (error) {
                        per = false
                    }
                )
            }
        });
        if (per)
            Notifier.success('Порядок успешно обновлен', 2);
        else
            Notifier.error('Произошла ошибка', 2);
    };
}
